/**
 * The icon set used across the app, backed by lucide-react.
 *
 * Generated by scripts/generateIconBarrel.mjs from map.js - edit the map, not this file.
 *
 * Every icon takes className, style, spin, rotate and onClick, and carries the
 * .ui-icon class hooks the stylesheets target.
 */

import { createIcon } from './createIcon'
import { ICON_MAP } from './map'

const make = (name) => createIcon(name, ICON_MAP[name])

export const PlusOutlined = make('PlusOutlined')
export const MinusOutlined = make('MinusOutlined')
export const MinusCircleOutlined = make('MinusCircleOutlined')
export const DeleteOutlined = make('DeleteOutlined')
export const EditOutlined = make('EditOutlined')
export const FormOutlined = make('FormOutlined')
export const SaveOutlined = make('SaveOutlined')
export const CopyOutlined = make('CopyOutlined')
export const CloseOutlined = make('CloseOutlined')
export const CheckOutlined = make('CheckOutlined')
export const ReloadOutlined = make('ReloadOutlined')
export const SyncOutlined = make('SyncOutlined')
export const SearchOutlined = make('SearchOutlined')
export const FilterOutlined = make('FilterOutlined')
export const ClearOutlined = make('ClearOutlined')
export const UploadOutlined = make('UploadOutlined')
export const CloudUploadOutlined = make('CloudUploadOutlined')
export const DownloadOutlined = make('DownloadOutlined')
export const PrinterOutlined = make('PrinterOutlined')
export const ShareAltOutlined = make('ShareAltOutlined')
export const SwapOutlined = make('SwapOutlined')
export const StopOutlined = make('StopOutlined')
export const LogoutOutlined = make('LogoutOutlined')
export const MoreOutlined = make('MoreOutlined')
export const LoadingOutlined = make('LoadingOutlined')
export const TranslationOutlined = make('TranslationOutlined')
export const CheckCircleOutlined = make('CheckCircleOutlined')
export const CheckCircleFilled = make('CheckCircleFilled')
export const CloseCircleOutlined = make('CloseCircleOutlined')
export const ExclamationCircleOutlined = make('ExclamationCircleOutlined')
export const InfoCircleOutlined = make('InfoCircleOutlined')
export const QuestionCircleOutlined = make('QuestionCircleOutlined')
export const WarningOutlined = make('WarningOutlined')
export const AlertOutlined = make('AlertOutlined')
export const NotificationOutlined = make('NotificationOutlined')
export const BellOutlined = make('BellOutlined')
export const ArrowLeftOutlined = make('ArrowLeftOutlined')
export const ArrowRightOutlined = make('ArrowRightOutlined')
export const ArrowUpOutlined = make('ArrowUpOutlined')
export const DownOutlined = make('DownOutlined')
export const UpOutlined = make('UpOutlined')
export const LeftOutlined = make('LeftOutlined')
export const RightOutlined = make('RightOutlined')
export const UserOutlined = make('UserOutlined')
export const UserAddOutlined = make('UserAddOutlined')
export const TeamOutlined = make('TeamOutlined')
export const ManOutlined = make('ManOutlined')
export const SmileOutlined = make('SmileOutlined')
export const CrownOutlined = make('CrownOutlined')
export const DollarOutlined = make('DollarOutlined')
export const WalletOutlined = make('WalletOutlined')
export const CreditCardOutlined = make('CreditCardOutlined')
export const BankOutlined = make('BankOutlined')
export const PercentageOutlined = make('PercentageOutlined')
export const ShoppingCartOutlined = make('ShoppingCartOutlined')
export const ShoppingOutlined = make('ShoppingOutlined')
export const ShopOutlined = make('ShopOutlined')
export const GiftOutlined = make('GiftOutlined')
export const TagOutlined = make('TagOutlined')
export const TagsOutlined = make('TagsOutlined')
export const FileTextOutlined = make('FileTextOutlined')
export const FileOutlined = make('FileOutlined')
export const FilePdfOutlined = make('FilePdfOutlined')
export const FileImageOutlined = make('FileImageOutlined')
export const PictureOutlined = make('PictureOutlined')
export const ReadOutlined = make('ReadOutlined')
export const CalendarOutlined = make('CalendarOutlined')
export const ClockCircleOutlined = make('ClockCircleOutlined')
export const FieldTimeOutlined = make('FieldTimeOutlined')
export const HistoryOutlined = make('HistoryOutlined')
export const HomeOutlined = make('HomeOutlined')
export const EnvironmentOutlined = make('EnvironmentOutlined')
export const GlobalOutlined = make('GlobalOutlined')
export const CompassOutlined = make('CompassOutlined')
export const CarOutlined = make('CarOutlined')
export const CoffeeOutlined = make('CoffeeOutlined')
export const LockOutlined = make('LockOutlined')
export const KeyOutlined = make('KeyOutlined')
export const SafetyOutlined = make('SafetyOutlined')
export const EyeOutlined = make('EyeOutlined')
export const EyeInvisibleOutlined = make('EyeInvisibleOutlined')
export const AppstoreOutlined = make('AppstoreOutlined')
export const UnorderedListOutlined = make('UnorderedListOutlined')
export const BarChartOutlined = make('BarChartOutlined')
export const PieChartOutlined = make('PieChartOutlined')
export const SettingOutlined = make('SettingOutlined')
export const StarOutlined = make('StarOutlined')
export const HeartOutlined = make('HeartOutlined')
export const MoonOutlined = make('MoonOutlined')
export const ThunderboltOutlined = make('ThunderboltOutlined')
export const WifiOutlined = make('WifiOutlined')
export const MailOutlined = make('MailOutlined')
export const PhoneOutlined = make('PhoneOutlined')
